import React, { useState } from 'react';
import styles from './FormStyle.css.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LegalTerms from '../LegalTerms';
import SearchInput from './SearchInput';
import useClickSubmit from '../../hooks/useClickSubmit';
import useInsightSubmit from '../../hooks/useInsightSubmit';
import { buildKeywordLink, flattenString } from '../../utils/helpers';
import Radium from 'radium';

const CustomInputForm = ({ isOptOut, offer, tracking }) => {
    const [ disabled, setDisabledState ] = useState(true);
    const [ interest, setInterest ] = useState('');
    const [ shouldExecute, setExecute ] = useState(false);

    useClickSubmit(isOptOut, tracking, shouldExecute);
    useInsightSubmit(interest, tracking, shouldExecute);

    const handleInputChange = (event) => {
        let interestValue = event.target.value;
        const query = flattenString(interestValue);
        setInterest(query);
        if (!!interestValue) {
            setDisabledState(false);
        } else {
            setDisabledState(true);
        };
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if(disabled) return;
        setExecute(true);
        const linkout = buildKeywordLink(offer.url, tracking, interest, isOptOut);
        let newTab = window.open();
        newTab.location = linkout;
    };

    const themedButton = Object.assign({},
        styles.submitButton,
        styles[`${tracking.theme}Button`],
        disabled && styles.disabledButton
    );

    return (
        <form style={styles.formContainer} onSubmit={handleFormSubmit}>
            <div style={styles.titleText}>or</div>
            <SearchInput 
                value={interest}
                handleChange={handleInputChange}
                name='Enter a Custom Interest...'
            />
            <LegalTerms email={tracking.EMAIL} isSearch/>
            <div style={styles.buttonGroup}>
                <button
                    type='submit'
                    style={themedButton}
                >
                    <span style={styles.buttonText}>Find Offers</span>
                    <FontAwesomeIcon
                        icon={['fal', 'angle-double-right']}
                        style={styles.buttonIcon}
                    />
                </button>
            </div>
        </form>
    )
};

export default Radium(CustomInputForm);